enum Actions {
  UPDATE_STATE = 'updateState',
}

export default Actions;
